"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var FireIcon = (0, react_2.forwardRef)(function (props, ref) {
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "16", viewBox: "0 0 15 16", fill: "none", ref: ref }, props),
        react_1.default.createElement("path", { d: "M4.16462 16C3.20979 14.5393 3.34584 12.6225 4.49746 11.3108C5.07989 10.5326 5.49916 9.6452 5.7302 8.70155C6.21393 9.39271 6.37151 10.2602 6.16165 11.0769C7.23778 9.8522 7.73601 8.22542 7.52999 6.60925C10.6179 8.65845 11.7089 12.6737 10.0818 16C19.2656 11.0769 12.3253 3.80309 11.1666 2.99078C11.6653 3.93085 11.533 5.08046 10.8337 5.88309C9.46539 0.996939 6.07536 1.52588e-05 6.07536 1.52588e-05C6.48217 2.46155 4.62073 5.26771 2.84559 7.38463C2.85497 6.45312 2.61676 5.53579 2.15526 4.72617C2.01966 6.48617 0.540375 7.9754 0.145899 9.84617C-0.408833 12.3077 0.552702 14.08 4.16462 16Z", fill: "#E03131" })));
});
exports.default = FireIcon;
//# sourceMappingURL=FireIcon.js.map